export const isProductionEnv = (): boolean => {
  const { NODE_ENV, REACT_APP_ENV } = process.env;

  return NODE_ENV === "production" && REACT_APP_ENV === "prod";
};
